/**
 * 认证 API 层
 */

import axios from 'axios'

// 确保携带 session cookie 用于后端登录校验
axios.defaults.withCredentials = true

/**
 * 钉钉SSO单点登录（新版）
 * 返回 { needLogin, mobile, name, ssoToken / userName }
 * @param {string} code 钉钉临时授权码
 */
export function ssoLogin (code) {
  return axios.post('/user/dingtalk/sso', { code })
}

/**
 * 运维人员手动登录（SSO流程第二步）
 * @param {string} mobile 手机号
 * @param {string} password 密码
 * @param {string} ssoToken SSO令牌
 */
export function adminLogin (mobile, password, ssoToken) {
  return axios.post('/user/dingtalk/admin-login', {
    mobile: mobile,
    password: password,
    ssoToken: ssoToken
  })
}

/**
 * 简单用户名密码登录（无验证码，浏览器直接访问用）
 * @param {string} userName
 * @param {string} password
 */
export function loginByPassword (userName, password) {
  return axios.post('/user/login/pwd', {
    userName: userName,
    password: password
  })
}

/**
 * 检查当前会话授权状态
 */
export function checkAuth () {
  return axios.get('/authentication')
}

export function getUserInfo () {
  return axios.get('/user/info')
}

export function logout () {
  return axios.get('/user/logout')
}



// WEBPACK FOOTER //
// ./src/api/auth.js